import { useEffect, useState } from 'react'
import { Alert, Button, Container, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { listEvents, markEventsRead } from '../actions/eventActions'
import Loader from '../components/Loader'
import Pagination from '../components/Pagination'
import Template from '../components/Template'

const formatEventDate = value => new Intl.DateTimeFormat('ar-SA', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
}).format(new Date(value))

const getEventIcon = type => {
    if(type === 'عزاء') return 'fas fa-praying-hands'
    if(type === 'حفل زواج') return 'fas fa-ring'
    if(type === 'حفل تخرج') return 'fas fa-user-graduate'
    if(type === 'أعياد') return 'fas fa-star'
    if(type === 'عقائق') return 'fas fa-baby'
    if(type === 'عشاء') return 'fas fa-utensils'
    return 'fas fa-calendar-check'
}

const Events = () => {
    const [eventTitle, setEventTitle] = useState('')
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()
    const { loading, error, events, count, page } = useSelector(state => state.events)

    const searchUrl = (key, value) => {
        const search = new URLSearchParams(location.search)
        if(search.has(key)) search.delete(key)
        if(key !== 'page') search.delete('page')
        search.append(key, value)
        return search.toString()
    }

    const eventSearchHandler = e => {
        e.preventDefault()
        history.push(`${location.pathname}?keyword=${eventTitle}`)
    }

    const resetSearchHandler = () => {
        setEventTitle('')
        history.push(location.pathname)
    }

    useEffect(() => {
        dispatch(listEvents(location.search))
    }, [dispatch, location])

    useEffect(() => {
        dispatch(markEventsRead())
    }, [dispatch])

    return (
        <Template>
            <h2 className='main__title'>الفعاليات</h2>
            <Container>
                <div className='events__header'>
                    <Button variant='info' onClick={resetSearchHandler}>
                        إظهار جميع الفعاليات
                    </Button>
                    <Form className='navigation__search users__search' onSubmit={eventSearchHandler}>
                        <Form.Control
                            type='text'
                            placeholder='ابحث بعنوان الفعالية'
                            className='mr-sm-2'
                            value={eventTitle}
                            onChange={({ target: { value } }) => setEventTitle(value)}
                        />
                        <Button variant='outline-success'>بحث</Button>
                    </Form>
                </div>

                {loading ? <Loader />
                    : error ? <Alert variant='warning'>{error}</Alert>
                        : <>
                            <div className='events'>
                                {events && events.map(event => (
                                    <article className='events__item' key={event._id}>
                                        <div className='events__icon'>
                                            <i className={getEventIcon(event.type)}></i>
                                        </div>
                                        <div className='events__content'>
                                            <div className='events__meta'>
                                                <span>{event.type}</span>
                                                <time>{formatEventDate(event.eventDate)}</time>
                                            </div>
                                            <h3>{event.title}</h3>
                                            {event.location && <p className='events__location'>
                                                <i className='fas fa-map-marker-alt'></i>
                                                {event.location}
                                            </p>}
                                            {event.body && <p className='events__body'>{event.body}</p>}
                                        </div>
                                    </article>
                                ))}
                            </div>
                            {events && <Pagination
                                count={count}
                                page={page}
                                searchHandler={searchUrl}
                            />}
                        </>}
            </Container>
        </Template>
    )
}

export default Events
